import migration150 from './1.5/1.5.0';
import migration160 from './1.6/1.6.0';

// Keys must stay <= the persist version derived from package.json (see store/index.ts),
// otherwise createMigrate skips them and they silently never run.
export const migrations = {
  150: migration150,
  160: migration160,
};
